import React from 'react';
import { Navigate } from 'react-router-dom';

function PrivateRouteAlcohol({ component: Component }) {
	const rawToken = localStorage.getItem('dtx001token');
	let hasToken = false;
	if (rawToken) {
		try {
			const parsed = JSON.parse(rawToken);
			hasToken = Boolean(parsed?.accessToken);
		} catch (e) {
			hasToken = false;
		}
	}
	// eslint-disable-next-line react/jsx-props-no-spreading
	if (hasToken) return Component;

	// 토큰 없이 접근 시 토스트 플래그 초기화 후 로그인 페이지로 이동
	sessionStorage.removeItem('hasShownLoginToast');
	return <Navigate to="/sign-in/dtx001" />;
}

export default PrivateRouteAlcohol;
